import type { Distance, SpatialRectangle } from "@pdfking/math"
import { AddMargins, BoundingBox, Outline } from "@pdfking/math"
import { FullMethodDispatcher } from "@pdfking/tfunc"

import type { PlotShape } from "#public"
import { PlotFunction } from "#public"

import { MatrixBox } from "./MatrixBox"

/** The axis-aligned box a shape occupies in the space it is written in.
 *
 * A group's box is its children's, seen through its own transform — which is
 * also why a rotated group's box is bigger than its contents. Media measures
 * its mask, not its position: that is what ends up visible. A path's box
 * holds its Bézier handles too. */
export const ShapeBounds: (shape: PlotShape) => SpatialRectangle<Distance> = FullMethodDispatcher<
  [PlotShape],
  SpatialRectangle<Distance>
>({
  [PlotFunction.PLOT_GROUP]: ({ matrix, shapes }) =>
    Outline(shapes.map(shape => MatrixBox(matrix, ShapeBounds(shape)))),
  [PlotFunction.PLOT_MEDIA]: ({ position, mask }) => AddMargins(position, mask),
  // a curve stays inside its handles' hull, so their box holds it
  [PlotFunction.PLOT_PATH]: ({ points }) =>
    BoundingBox(...points.flatMap(({ before, after, ...anchor }) => [anchor, before, after])),
  [PlotFunction.PLOT_RECT]: ({ position }) => position,
  [PlotFunction.PLOT_TEXT]: ({ position }) => position,
})
